import { NgModule } from '@angular/core';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { SharedModule } from 'ngx-mat-esign360/lib/shared/shared.module';
import { MatButtonModule, MatIconModule, MatToolbarModule } from '@angular/material';
import { MainContentComponent } from './components/main-content/main-content.component';
import { MgmtMainMenuComponent } from './components/mgmt-main-menu/mgmt-main-menu.component';
import { MgmtPage } from './pages/mgmt/mgmt.page';
import { RouterModule } from '@angular/router';
import { FullScreenComponent } from './components/full-screen/full-screen.component';

@NgModule({
  declarations: [
    MainMenuComponent,
    MainContentComponent,
    MgmtMainMenuComponent,
    MgmtPage,
    FullScreenComponent,
  ],
  imports: [SharedModule, MatToolbarModule, MatButtonModule, MatIconModule, RouterModule],
  exports: [
    MainMenuComponent,
    MainContentComponent,
    MgmtMainMenuComponent,
    MgmtPage,
    FullScreenComponent,
  ],
})
export class LayoutModule {}
